const channelColors = Object.freeze({
	1: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	2: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	3: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	4: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	5: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	6: {
		'ARO SPONT': '#b5c4f0',
		'Slow Wave': '#f7ef92'
	},
	7: {},
	8: {},
	9: {},
	10: {},
	11: {
		'Snore': '#bfbd75'
	},
	12: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea': '#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	13: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea': '#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	14: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea': '#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	15: {
		'Obstructive Apnea': '#bf8975',
		'Central Apnea': '#ff7a7a',
		'Mixed Apnea': '#292e34',
		'Obstructive Hypopnea': '#c4e2e2',
		'Central Hypopnea': '#343961',
		'Mixed Hypopnea': '#ffb9b9',
		'Unsure Respiratory Event': '#ff4719',
		'Respiratory Artifact': '#ffdab9',
		'Respiratory Paradox': '#90251d',
		'Cheyne Stokes Breathing': '#e3a624',
		'RERA': '#1c2039'
	},
	16: {
		'SpO2 Desat': '#71c3fa',
		'SpO2 Artifact': '#e88db7'
	},
	17: {
		'Limb movement (Left)': '#e88db7'
	},
	18: {
		'Limb movement (Right)': '#e88db7'
	},
	19: {},
	20: {},
	21: { 'PtcCO2 Event': '#71c3fa' },
	22: {}
})

export default channelColors